import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AbstractShapeComponent } from '../abstract-shape.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- svg needs attribute selectors
  selector: '[h3Polygon]',
  templateUrl: './polygon.component.html',
  styleUrls: ['../../shape-parts/outline-host.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PolygonComponent extends AbstractShapeComponent implements OnInit {
  showModelInputPoints$!: Observable<boolean>;

  override ngOnInit() {
    super.ngOnInit();
    this.showModelInputPoints$ = this.buildShowModelInputPoints$();
  }

  protected override buildAllSubpointInfo$() {
    return super.buildAllSubpointInfo$().pipe(
      tap((allSubpointInfo) => {
        for (const subpointInfo of allSubpointInfo) {
          subpointInfo.cursor = 'var(--h3-polygon-subpoint-cursor)';
        }
      }),
    );
  }

  private buildShowModelInputPoints$() {
    return combineLatest([this.isFocused$, this.store('editMode').$]).pipe(
      map(
        ([isFocused, editMode]) =>
          isFocused && (editMode === 'clicky' || editMode === 'select'),
      ),
    );
  }
}
